<template>
  <qx-card title="列表">
    <OrderDialog ref="OrderDialog" @sub="getData" />
    <InvoiceDialog ref="invoiceDialog" @sub="getData" />
    <WriteOffDialog ref="writeOffDialog" @sub="getData" />
    <LogRightDialog ref="logRightDialog" busiCode="230005" />
    <section slot="titleRight">
      <qx-permpisions permpisions="2000114">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="orderBillInfoBO.ajax?cmd=doQuery"
          :params="fullSearchData"
          bizName="应收结算账单信息导出"
          bizCode="exp100061"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 账单号 -->
                <section
                  v-if="scope.column.property === 'billNumber'"
                  @click="toOrder(scope.row.billNumber)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 账单号 end -->
                <!-- 订单收入合计 -->
                <section v-else-if="scope.column.property === 'orderTotal'">
                  <span>
                    {{
                      scope.row.costPriceDouble +
                      scope.row.incomeExceptionFeeDouble
                    }}
                  </span>
                </section>
                <!-- 订单收入合计 end -->
                <!-- 确认收入 -->
                <section v-else-if="scope.column.property === 'sureGet'">
                  <span>
                    {{
                      scope.row.costPriceDouble +
                      scope.row.confirmDiffAmountDouble +
                      scope.row.incomeExceptionFeeDouble
                    }}
                  </span>
                </section>
                <!-- 确认收入 end -->
                <!-- 核销金额 -->
                <section
                  v-else-if="scope.column.property === 'checkAmountDouble'"
                >
                  <template v-if="checkPermpisions('2000119')">
                    <span
                      class="primary cur"
                      @click="showWriteOffDialog(scope.row)"
                      >{{ scope.row[scope.column.property] }}</span
                    >
                  </template>
                  <template v-else>
                    <span>{{ scope.row[scope.column.property] }}</span>
                  </template>
                </section>
                <!-- 核销金额 end -->
                <!-- 发票 -->
                <section v-else-if="scope.column.property === 'receiptNumber'">
                  <template v-if="checkPermpisions('2000113')">
                    <span
                      class="primary cur"
                      @click="showInvoiceDialog(scope.row)"
                      >{{ scope.row[scope.column.property] }}</span
                    >
                  </template>
                  <template v-else>
                    <span>{{ scope.row[scope.column.property] }}</span>
                  </template>
                </section>
                <!-- 发票 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '2000112',
                    showCondition: true,
                    name: '回退',
                    event: () => back(scope.row.billNumber),
                  },
                  {
                    permpisions: '2000116',
                    showCondition: scope.row.billSts === 0,
                    name: '增加订单',
                    event: () => showOrderDialog(scope.row, 'add'),
                  },
                  {
                    permpisions: '2000117',
                    showCondition: scope.row.billSts === 0,
                    name: '减少订单',
                    event: () => showOrderDialog(scope.row, 'del'),
                  },
                  {
                    permpisions: '2000120',
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.billNumber.substr(2)),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import OrderDialog from './orderDialog/orderDialog';
import InvoiceDialog from './invoiceDialog/invoiceDialog';
import WriteOffDialog from './writeOffDialog/writeOffDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  customerBillList,
  customerBillBack,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    OrderDialog,
    InvoiceDialog,
    WriteOffDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'billNumber', label: '账单号', fixed: true },
          { prop: 'createDate', label: '创建时间' },
          { prop: 'creatorName', label: '创建人' },
          { prop: 'orderNum', label: '账单数量' },
          { prop: 'customName', label: '对账名称' },
          { prop: 'costPriceDouble', label: '订单收入' },
          { prop: 'incomeExceptionFeeDouble', label: '异常款' },
          { prop: 'orderTotal', label: '订单收入合计' },
          { prop: 'confirmDiffAmountDouble', label: '对账调整' },
          { prop: 'sureGet', label: '确认收入' },
          { prop: 'checkAmountDouble', label: '核销金额' },
          { prop: 'syCheckDouble', label: '未核销' },
          { prop: 'realIncomeDouble', label: '实收' },
          { prop: 'receiptNumber', label: '发票' },
          { prop: 'billStsName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: customerBillList,
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toOrder (billNumber) {
      this.jump({
        label: '应收订单',
        url: '/manage/getPay/customer/order?billNumber=' + billNumber,
      });
    },
    showOrderDialog (item, type) {
      this.$refs.OrderDialog.show(item, type);
    },
    showInvoiceDialog (item) {
      this.$refs.invoiceDialog.show(item);
    },
    showWriteOffDialog (item) {
      this.$refs.writeOffDialog.show(item);
    },
    async back (billNumber) {
      const confirmRes = await this.$confirm('是否回退?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const subRes = await customerBillBack({ billNumbers: billNumber });
        if (!subRes.failed) {
          this.$message.success('回退成功【已在油卡充值核销完成的油卡抵充除外】');
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
